/**
 * ダッシュボードの案内に出す CLI の呼び方（1 か所）。2026-09-27 cli-name の後に Kumo Creator が追加。
 *
 * WHY `npx kumo` と書かないか: npm の `kumo` という名前は別人のパッケージ（Research の公開準備の調査・docs/cli-rename.md）。
 *   `npx kumo …` をそのまま打つと他人のコードが動く。サイト（apps/site/site.config.mjs の cliPackage）と同じく
 *   `npx <CLI のパッケージ名>` で案内する。
 * 名前がまた変わったら: ここと packages/cli/src/lib/cliName.ts・apps/site/site.config.mjs を直す（手順は docs/cli-rename.md）。
 * ブラウザ向けの別パッケージなので @kumo/cli の定数は import できない = ここが dashboard 側の 1 か所。
 * 2026-09-29（creator/xkumo・founder の決定 MASTER-PLAN「XKumo」）: コマンド名は `kumo` → `xkumo`。パッケージ名 @kumo/cli は変えない
 *   （npm の名前は公開準備で別に決める）= 当時は npx に @kumo/cli を付けて案内し、入れた後に打つ名前が `xkumo`。
 * 2026-09-30（console/kumodeck・founder の決定 MASTER-PLAN「KUMODeck」= xkumo.com が第三者の持ち物のため改名）: コマンド名は `xkumo` → `kumodeck`。
 *   パッケージ名 @kumo/cli は今回も変えない（決定に無い = 変えない）。旧名 `xkumo` の別名も無い。
 * 2026-10-02（creator/npm-name-kumodeck・founder の決定 MASTER-PLAN §0「CLI の npm の名前は kumodeck」）: 公開の npm の名前は `kumodeck`（scope なし）。
 *   WHY: 誰も持っていない `@kumo/cli` を案内すると、他人がその名前を取って悪いプログラムを配れる。workspace の名前 @kumo/cli は変えない
 *   （npm に出すときだけ packages/cli/scripts/stage-publish.mjs が kumodeck にする）。正本は packages/cli/src/lib/cliName.ts の CLI_PACKAGE と同じ値。
 *   案内に `@kumo/cli` が戻ると packages/cli/src/npmName.test.ts が落ちる。
 */
export const CLI_PACKAGE = 'kumodeck';
/**
 * 入れた CLI のコマンド名（packages/cli/src/lib/cliName.ts の CLI_NAME と同じ値・package.json の bin）。
 * 画面の「手元で打つ行」（機能の ON の `<CLI_NAME> features on …`・`<CLI_NAME> config push`）はここから作る。旧名 `kumo`・`xkumo` の別名は無い。
 * 辞書（i18n）の文に入れるときは `{cliName}` と書く（i18n/index.ts が {product} と同じく自動で埋める・直書きは wording.test.ts が落とす）。
 * `{cli}` は別物（以前ホームの connect の頼み文で `npx kumodeck` を入れた場所。2026-10-11 console/one-connect からは webConnect.ts connectPromptFor が CLI を直接受け取る）= 混ぜない
 */
export const CLI_NAME = 'kumodeck';
/** 案内に出す呼び方（インストールなしで動く形） */
export const CLI = `npx ${CLI_PACKAGE}`;
